import {
  CatalogAccessGrid,
  type CatalogAccessGridMessages,
} from '@webapp/modules/purchasing/components/CatalogAccessGrid'
import { type CatalogPermissionSecondaryCategoryConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionSecondaryCategoryConfig'
import { type V1User } from '@webapp/platform/iam'
import messages from './messages'

export interface IUserAccessGridProps {
  secondaryCategory: CatalogPermissionSecondaryCategoryConfig
  userOptions: V1User[]
  isLoading: boolean
  isSaving: boolean
  onSave: (selectedUserIds: number[]) => void
  onCancel?: () => void
}

const gridMessages: CatalogAccessGridMessages = {
  header: messages.userAccessHeader,
  selectAll: messages.selectAll,
  deselectAll: messages.deselectAll,
  save: messages.save,
  cancel: messages.cancel,
  emptyState: messages.emptyState,
}

export const UserAccessGrid = ({
  secondaryCategory,
  userOptions,
  isLoading,
  isSaving,
  onSave,
  onCancel,
}: IUserAccessGridProps) => (
  <CatalogAccessGrid
    options={userOptions}
    grantedIds={secondaryCategory.grantedUserIds}
    getOptionLabel={(user) => user.fullName}
    resetKey={secondaryCategory.id}
    columns={3}
    isLoading={isLoading}
    isSaving={isSaving}
    onSave={onSave}
    onCancel={onCancel}
    messages={gridMessages}
  />
)
